export const SET_THEME_REQUESTED = 'SET_THEME_REQUESTED';
export const SET_THEME_COMPLETED = 'SET_THEME_COMPLETED';

export const GET_THEME_REQUESTED = 'GET_THEME_REQUESTED';
export const GET_THEME_COMPLETED = 'GET_THEME_COMPLETED';
